import React from 'react'
import PropTypes from 'prop-types'

// Components
import AnimateSplitText from '../../animation/AnimateSplitText'
import GridItem from '../../GridItem'
import Spacer from '../../Spacer'
import RichText from '../../RichText'
import AnimateSlideIn from '../../animation/AnimateSlideIn'

// Vars
import { Label, Cta } from '../../../styles/vars/textStyles.style'
import { colors } from '../../../styles/vars/colors.style'

// Styles
import {
  MapNavigationItem,
  MapNavigationImage,
  MapNavigationImageInner,
  MapNavigationItemText,
  MapNavigationItemBar,
} from './index.style'

const MapNavItem = ({
  id,
  label,
  heading,
  text,
  color,
  image,
  active,
  setActive,
  delay,
}) => {
  return (
    <GridItem desk={3}>
      <MapNavigationItem href={`#`} active={active} onClick={setActive}>
        <MapNavigationImage>
          <AnimateSlideIn id={`${id}-image`} delay={delay} scale={1.3}>
            <MapNavigationImageInner active={active}>
              <img src={image} width={480} height={230} alt={text} />
            </MapNavigationImageInner>
          </AnimateSlideIn>
        </MapNavigationImage>
        <MapNavigationItemText>
          <Spacer size={34} />
          <AnimateSplitText id={`${id}-label`} delay={delay + 1}>
            <Label color={colors.light} bgColor={color}>
              {label}
            </Label>
          </AnimateSplitText>
          <Spacer size={33} />
          <RichText
            id={`${id}-heading`}
            content={heading}
            delay={delay + 1.1}
          />
          <Spacer size={16} />
          <AnimateSplitText id={`${id}-text`} delay={delay + 1.2}>
            <Cta color={colors.light} textTransform={`none`}>
              {text}
            </Cta>
          </AnimateSplitText>
          <Spacer size={40} />
        </MapNavigationItemText>
        <MapNavigationItemBar active={active} color={color} />
      </MapNavigationItem>
    </GridItem>
  )
}

MapNavItem.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  heading: PropTypes.object,
  text: PropTypes.string,
  color: PropTypes.string,
  image: PropTypes.string,
  active: PropTypes.bool,
  setActive: PropTypes.func,
  delay: PropTypes.number.isRequired,
}

export default MapNavItem
